import React from 'react';
import PropTypes from 'prop-types';
import styles from './backgroundimage.module.scss';

class BackgroundImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    const { img } = this.props;
    return (
      <img className={styles.bgimage}
          srcSet={`${img.tall.url} 600w, ${img.medium.url} 1024w, ${img.url} 1400w`}
          src={`${img.url}`}
          alt=''
          sizes="100vw"
          onLoad={this.props.onElementLoad}
      />
    );
  }
}

BackgroundImage.defaultProps = { };

BackgroundImage.propTypes = { };

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/components/Section/BackgroundImage/index.jsx